/** «راهنمای شروع»: the member asks to see the tour again (the menu entry sets it, the tour clears it). */
class Replay {
  requested = $state(false);
  open(): void {
    this.requested = true;
  }
  close(): void {
    this.requested = false;
  }
}
export const replay = new Replay();
